// extracted by mini-css-extract-plugin
export default {"container":"OrgPersonalToggle_container__YNuqZ","text":"OrgPersonalToggle_text__3t37b"};